<template>
  <div class="row justify-content-center">
    <div class="col-xl-12">
      <div class="ugs-selected-count">
        <i class="uil-users-alt" aria-hidden="true"></i>
        {{ $t('general.number_of_selected_users') }}: {{ selectedUsersCount }}
      </div>

      <StepperBreadcrumb
        v-model="activeTab"
        :items="tabItems"
        :aria-label="$t('general.user_and_groups')"
        class="ugs-tabs"
      />

      <div v-if="(activeTab === 0 && isUsersLoading) || (activeTab === 1 && isGroupsLoading)" role="status" class="p-2">
        <span class="spinner-border spinner-border-sm"></span>
      </div>
      <div class="ugs-tab-content">
        <!--tab:  kullanicilar listesi-->
        <div v-if="isUsersActive" v-show="activeTab === 0" key="users-panel" class="ugs-tab-panel">
          <div class="ugs-search">
            <i class="uil-search ugs-search__icon" aria-hidden="true"></i>
            <input v-model="user_filters.search"
                   :placeholder="$t('general.first_name_and_last_name_or_id_no')"
                   class="ugs-search__input"
                   type="search"
                   v-on:keydown.enter.prevent="triggerUserFilterSearch"/>
          </div>
          <div class="ugs-action-bar">
            <div class="ugs-action-bar__left">
              <multiple-select-input v-model="selectedUserPerPage"
                                     :allow-empty="false"
                                     :multiple="false"
                                     :searchable="false"
                                     :show-labels="false"
                                     :values="perPageOptions"
                                     class="ugs-per-page-select"
              />
              <!-- Sort -->
              <MultipleSelectInput
                  v-model="selectedUserSort"
                  :values="userSortOptions"
                  :allow-empty="false"
                  :searchable="false"
                  :show-labels="false"
                  label="name"
                  track-by="id"
                  class="ugs-sort-select"
              />
            </div>
            <!-- "Tumunu isaretle" + filtre SAGDA: UserFilter paneli
                 ikonun sag kenarina hizalanarak aciliyor. Ikon solda
                 kaldiginda 720px'lik panel sola dogru acilip icerik
                 alanini asiyor ve sol navigasyonun altinda kaliyordu. -->
            <div class="ugs-action-bar__right">
              <button class="btn btn-sm btn-soft-secondary ugs-bulk-btn" type="button" @click="allUserToggle()">
                <i class="uil-check-square"></i> {{ selectAllUserText }}
              </button>
              <!-- Filter -->
              <a :uk-tooltip="$t('general.filter_list')" class="ugs-icon-btn" href="#">
                <i class="uil-filter"></i>
              </a>
              <UserFilter ref="childComponentRef" :show_only_unassigned_users="show_only_unassigned_users" :has-competency="hasCompetency"
                          @getFilter="filterUsers($event)"></UserFilter>
            </div>
          </div>

          <!-- Table -->
          <div class="table-responsive users-table">
            <table class="table align-items-center">
              <thead>
              <tr>
                <th scope="col">{{ this.$t('general.first_name_and_last_name') }}</th>
                <th scope="col">{{ this.$t('general.title_position') }}</th>
                <th scope="col">{{ $t("general.corporation") }}</th>
                <th scope="col">{{ $t('general.their_group') }}</th>
                <th scope="col">{{ this.$t('general.added_at') }}</th>
                <th scope="col"></th>
              </tr>
              </thead>
              <tbody class="list">
              <!--user item-->
              <tr v-for="(item, index) in formattedUsers" :key="item.id">
                <th scope="row">
                  <div class="media align-items-center">
                    <div class="form-group mb-0 checkbox-wrapper">
                      <input :id="'user_checkbox_' + item.id" 
                             :checked="isUserChecked(item.id)"
                             :disabled="isUserFromGroup(item.id)"
                             :value="item.id" 
                             class="user-checkbox"
                             type="checkbox" 
                             @change="handleUserCheckChange($event, item.id)"
                             @click="userChangeCheckItem"/>
                    </div>
                    <div class="ugs-avatar-wrap">
                      <div class="avatar-parent-child" style="width: max-content">
                        <AvatarOrIcon :src="item.photo_link" :size-px="32"/>
                        <span :class="item.is_online ? 'bg-success' : 'bg-offline'
                            " class="avatar-child avatar-badge"></span>
                      </div>
                    </div>
                    <div class="media-body ml-4">
                        <span class="name h6 mb-0 text-sm">
                          {{ item.name + " " + item.surname }}
                          <span v-if="isUserFromGroup(item.id)" class="group-user-badge"
                                :title="$t('general.selected_from_group')" uk-tooltip>
                            <i class="uil-users-alt"></i>
                          </span>
                        </span>
                      <small class="d-block font-weight-bold">#{{ item.id }}</small>
                    </div>
                  </div>
                </th>
                <td>{{ item.title }}</td>
                <td>{{ item.corporateName }}</td>
                <td>{{ item.group }}</td>
                <td>{{ item.created_at }}</td>
                <td class="text-right">
                  <!-- Actions -->
                  <div class="actions ml-3">
                    <a class="btn btn-icon btn-hover btn-sm btn-circle" uk-toggle="target: #modal-profile"
                       :uk-tooltip="$t('general.user_profil')" @click="user_filters.activeItem = item">
                      <i class="uil-user"></i>
                    </a>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
            <pagination :pagination="user_filters.pagination" @changePage="setPage($event, 'user_filters')">
            </pagination>
            <!-- modalClosed SART: activeItem sifirlanmazsa modal kapandiktan
                 sonra da set kalir. Sekme panelleri `v-if` ile render edildigi
                 icin sekme degistirmek UserProfile'i yeniden mount eder,
                 mounted() da modalInstance.show() cagirir — profil her sekme
                 gecisinde yeniden aciliyordu. -->
            <UserProfile v-if="formattedUserDetail && user_filters.activeItem"
                         :item="user_filters.activeItem"
                         :user_detail="formattedUserDetail"
                         @modalClosed="user_filters.activeItem = null"></UserProfile>
          </div>
        </div>

        <!--tab: gruplar listesi-->
        <div v-if="isGroupsActive" v-show="activeTab === 1" key="groups-panel" class="ugs-tab-panel">
          <div class="ugs-search">
            <i class="uil-search ugs-search__icon" aria-hidden="true"></i>
            <input v-model="group_filters.search"
                   class="ugs-search__input"
                   :placeholder="$t('general.group_name')"
                   type="search"
                   v-on:keydown.enter.prevent="triggerGroupFilterSearch"/>
          </div>
          <div class="ugs-action-bar">
            <div class="ugs-action-bar__left">
              <button class="btn btn-sm btn-soft-secondary ugs-bulk-btn" type="button"
                      @click="allGroupToggle(all_group_checked)">
                <i class="uil-check-square"></i> {{ selectAllGroupText }}
              </button>
            </div>
            <div class="ugs-action-bar__right">
              <!-- Sort -->
              <MultipleSelectInput
                  v-model="selectedGroupSort"
                  :values="groupSortOptions"
                  :allow-empty="false"
                  :searchable="false"
                  :show-labels="false"
                  label="name"
                  track-by="id"
                  class="ugs-sort-select"
              />
            </div>
          </div>

          <!-- Table -->
          <div class="table-responsive users-table">
            <table class="table align-items-center">
              <thead>
              <tr>
                <th scope="col">
                  {{ $t("user_group.list.name") }}
                </th>
                <th scope="col">
                  {{ $t("user_group.list.user_count") }}
                </th>
                <th scope="col">
                  {{ $t("general.created_at") }}
                </th>
              </tr>
              </thead>
              <tbody class="list">
              <!--group item-->
              <tr v-for="(item, index) in formattedGroupItems" :key="item.id">
                <th scope="row">
                  <div class="media align-items-center">
                    <input :id="'group_checkbox_' + item.id" 
                           v-model="checked_groups" 
                           :value="item.id" 
                           class="group-checkbox"
                           type="checkbox" 
                           @click="groupChangeCheckItem"/>
                    <div class="ugs-avatar-wrap">
                      <div class="avatar-parent-child">
                        <i class="icon-feather-users"></i>
                        <span class="avatar-child avatar-badge bg-success" />
                      </div>
                    </div>
                    <div class="media-body ml-4">
                      <a class="name h6 mb-0 text-sm" @click="$router.push({
                          name: 'company.user.group.edit',
                          params: { id: item.id },
                        })
                          ">{{ item.name }}</a>
                      <small class="d-block font-weight-bold">#{{ item.id }}</small>
                    </div>
                  </div>
                </th>
                <td>{{ item.count }}</td>
                <td>{{ item.created_at }}</td>
              </tr>
              </tbody>
            </table>
            <pagination :pagination="group_filters.pagination" @changePage="setPage($event, 'group_filters')">
            </pagination>
          </div>
        </div>
        <!--users who requested trainings-->

        <div v-if="case_detail === 'usersRequestedTraining'" v-show="activeTab === 2" key="requests-panel" class="ugs-tab-panel">
          <div class="ugs-search">
            <i class="uil-search ugs-search__icon" aria-hidden="true"></i>
            <input v-model="user_filters.search"
                   :placeholder="$t('general.first_name_and_last_name_or_id_no')"
                   class="ugs-search__input"
                   type="search"
                   v-on:keydown.enter.prevent="triggerUserFilterSearch"/>
          </div>
          <div class="ugs-action-bar">
            <div class="ugs-action-bar__left"></div>
            <div class="ugs-action-bar__right">
              <!-- Sort -->
              <MultipleSelectInput
                  v-model="selectedUserSort"
                  :values="userSortOptions"
                  :allow-empty="false"
                  :searchable="false"
                  :show-labels="false"
                  label="name"
                  track-by="id"
                  class="ugs-sort-select"
              />
              <!-- Filter -->
              <!-- <UserFilter @getFilter="filterUsers($event)" ref="childComponentRef"></UserFilter> -->
            </div>
          </div>

          <!-- Table -->
          <div class="table-responsive users-table">
            <table class="table align-items-center">
              <thead>
              <tr>
                <th scope="col">{{ this.$t('general.first_name_and_last_name') }}</th>
                <th scope="col">{{ this.$t('general.title_position') }}</th>
                <th scope="col">{{ $t('general.their_group') }}</th>
                <th scope="col">{{ this.$t('general.added_at') }}</th>
                <th scope="col"></th>
              </tr>
              </thead>
              <tbody class="list">
              <!--user item-->
              <tr v-for="(item, index) in formattedUserRequested" :key="index">
                <th scope="row">
                  <div class="media align-items-center">

                    <div class="ugs-avatar-wrap">
                      <div class="avatar-parent-child" style="width: max-content">
                        <AvatarOrIcon :src="item.photo_link" :size-px="32"/>
                        <span :class="item.is_online ? 'bg-success' : 'bg-offline'
                            " class="avatar-child avatar-badge"></span>
                      </div>
                    </div>
                    <div class="media-body ml-4">
                        <span class="name h6 mb-0 text-sm">{{
                            item.name + " " + item.surname
                          }}</span>
                      <small class="d-block font-weight-bold">#{{ item.id }}</small>
                    </div>
                  </div>
                </th>
                <td>{{ item.title }}</td>
                <td>{{ item.group }}</td>
                <td>{{ item.created_at }}</td>
                <td class="text-right">
                  <!-- Actions -->
                  <div class="actions ml-3">
                    <a class="btn btn-icon btn-hover btn-sm btn-circle" uk-toggle="target: #modal-profile"
                       :uk-tooltip="$t('general.user_profil')" @click="user_filters.activeItem = item">
                      <i class="uil-user"></i>
                    </a>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
            <pagination :pagination="userRequestedTraining.pagination" @changePage="setPage($event, 'user_filters')">
            </pagination>
            <!-- modalClosed SART: activeItem sifirlanmazsa modal kapandiktan
                 sonra da set kalir. Sekme panelleri `v-if` ile render edildigi
                 icin sekme degistirmek UserProfile'i yeniden mount eder,
                 mounted() da modalInstance.show() cagirir — profil her sekme
                 gecisinde yeniden aciliyordu. -->
            <UserProfile v-if="formattedUserDetail && user_filters.activeItem"
                         :item="user_filters.activeItem"
                         :user_detail="formattedUserDetail"
                         @modalClosed="user_filters.activeItem = null"></UserProfile>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/core/services";
import moment from "moment";
import Pagination from "@/assets/components/Pagination";
import UserProfile from "@/view/company/User/UserProfile/index.vue";
import UserFilter from "@/view/company/User/Filter";

import user_module, {
  BASE_URL as USER_BASE_URL,
  GET_ITEMS as USER_GET_ITEMS,
  ITEMS as USER_ITEMS,
  MODULE_NAME as USER_MODULE_NAME,
} from "@/core/services/store/user.module";

import user_detail_module, {
  GET_ITEM as GET_USER_DETAIL,
  ITEM as USER_DETAIL,
  MODULE_NAME as USER_DETAIL_MODULE,
} from "@/core/services/store/user_detail.module";

import group_module, {
  BASE_URL as GROUP_BASE_URL,
  GET_ITEMS as GROUP_GET_ITEMS,
  ERROR as GROUP_ERROR,
  ITEMS as GROUP_ITEMS,
  MODULE_NAME as GROUP_MODULE_NAME,
} from "@/core/services/store/user_group.module";

import company_module, {
  MODULE_NAME as COMPANY_MODULE,
  ONLINE_USERS,
} from "@/core/services/store/company.module";
import {GET_ITEMS as GET_USER} from "@/core/services/store/REST.module";
import AvatarOrIcon from "@/view/components/icons/AvatarOrIcon.vue";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput.vue";
import StepperBreadcrumb from "@/view/company/components/breadcrumb/StepperBreadcrumb.vue";
import {
  getAssignedCorporateAccess,
  applyAssignedCorporateToFilter,
} from "@/core/services/userCorporateAccess.service";

const _USER_MODULE = USER_MODULE_NAME;
const _GROUP_MODULE = GROUP_MODULE_NAME;
const _USER_DETAIL_MODULE = USER_DETAIL_MODULE;
const _COMPANY_MODULE = COMPANY_MODULE;
export default {
  name: "UserGroupSelection",
  components: {
    UserProfile,
    UserFilter,
    Pagination,
    AvatarOrIcon,
    MultipleSelectInput,
    StepperBreadcrumb
  },
  props: {
    assignment_id: {
      required: false,
      default: null,
    },
    added_users: {
      required: false,
      default: () => {
        return [];
      },
    },
    added_groups: {
      required: false,
      default: () => {
        return [];
      },
    },
    with_description: {
      required: false,
      default: false,
    },
    allow_both_selection: {
      required: false,
      default: false,
    },
    case_detail: {
      required: false,
      default: null,
    },
    checked_training: {
      required: false,
      default: null,
    },
    show_only_unassigned_users: false,
    hasCompetency: {
      type: Boolean,
      default: false,
    },
    isUsersActive: {
      type: Boolean,
      default: true,
    },
    isGroupsActive: {
      type: Boolean,
      default: true,
    },
    isUserListIncluded: {
      // grup içindeki users id'ler için kullanılacak
      type: Boolean,
      default: false,
    },
    company_id: {
      type: Number,
      required: false,
      default: null,
    },
    notAssignmentCompleted: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      usersListReady: false,
      groupsListReady: false,
      userRequestId: 0,
      groupRequestId: 0,
      isUsersLoading: true,
      isGroupsLoading: true,
      activeTab: 0,
      all_user_checked: true,
      all_group_checked: true,
      selectAllUserText: this.$t("general.Select All"),
      selectAllGroupText: this.$t("general.Select All"),
      checked_users: [],
      checked_groups: [],
      checked_group_users: [],
      checked_user_page: [],
      temp_page: [],
      user_filters: {
        pagination: null,
        activeItem: null,
        page: 1,
        per_page: 10,
        search: null,
        order: "desc",
        sort: "id",
      },
      group_filters: {
        pagination: null,
        activeItem: null,
        page: 1,
        per_page: 10,
        search: null,
        order: "desc",
        sort: "id",
      },
      userRequestedTraining: {},
      lastFilter: null,
      userSortOptions: [],
      groupSortOptions: []
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_USER_MODULE, user_module);
    registerStoreModule(_GROUP_MODULE, group_module);
    registerStoreModule(_USER_DETAIL_MODULE, user_detail_module);
    registerStoreModule(_COMPANY_MODULE, company_module);
  },
  computed: {
    perPageOptions() {
      return [10, 50, 100, 500, 1000, 2500].map((v) => ({ id: v, name: String(v) }));
    },
    tabItems() {
      const items = [];
      if (this.isUsersActive) {
        items.push({
          label: `${this.$t('users.users')} (${this.user_items.total || 0})`,
          icon: 'uil-user'
        });
      }
      if (this.isGroupsActive) {
        items.push({
          label: `${this.$t('general.user_groups')} (${this.group_items.total || 0})`,
          icon: 'uil-users-alt'
        });
      }
      if (this.case_detail === 'usersRequestedTraining') {
        items.push({
          label: `${this.$t('general.training_requesters')} (${this.userRequestedTraining.total || 0})`,
          icon: 'uil-users-alt'
        });
      }
      return items;
    },
    selectedUserPerPage: {
      get() {
        return this.perPageOptions.find((o) => o.id === Number(this.user_filters.per_page)) || this.perPageOptions[0];
      },
      set(value) {
        const next = value && value.id ? Number(value.id) : 10;
        if (Number(this.user_filters.per_page) === next) return;
        this.user_filters.per_page = next;
        this.filterUsers();
      },
    },
    selectedUserSort: {
      get() {
        const key = `${this.user_filters.sort}_${this.user_filters.order}`;
        return this.userSortOptions.find(opt => opt.id === key) || null;
      },
      set(value) {
        if (value) {
          const lastUnderscoreIndex = value.id.lastIndexOf('_');
          const sort = value.id.substring(0, lastUnderscoreIndex);
          const order = value.id.substring(lastUnderscoreIndex + 1);
          this.user_filters.sort = sort;
          this.user_filters.order = order;
          this.user_filters.page = 1;
          this.filterUsers();
        }
      }
    },
    selectedGroupSort: {
      get() {
        const key = `${this.group_filters.sort}_${this.group_filters.order}`;
        return this.groupSortOptions.find(opt => opt.id === key) || null;
      },
      set(value) {
        if (value) {
          const lastUnderscoreIndex = value.id.lastIndexOf('_');
          const sort = value.id.substring(0, lastUnderscoreIndex);
          const order = value.id.substring(lastUnderscoreIndex + 1);
          this.group_filters.sort = sort;
          this.group_filters.order = order;
          this.group_filters.page = 1;
          this.filterGroups();
        }
      }
    },
    onlineUsers() {
      return store.getters[_COMPANY_MODULE + "/" + ONLINE_USERS];
    },
    user_detail: {
      get() {
        return store.getters[USER_DETAIL_MODULE + "/" + USER_DETAIL];
      },
      set(value) {
      },
    },
    user_items: {
      get() {
        if (this.isUsersLoading || !this.usersListReady) return { data: [], total: 0 };
        return store.getters[USER_MODULE_NAME + "/" + USER_ITEMS] || { data: [], total: 0 };
      },
      set(value) {
      },
    },
    group_items: {
      get() {
        if (this.isGroupsLoading || !this.groupsListReady) return { data: [], total: 0 };
        return store.getters[GROUP_MODULE_NAME + "/" + GROUP_ITEMS] || { data: [], total: 0 };
      },
      set(value) {
      },
    },
    error: {
      get() {
        return store.getters[ASSIGNMENT_MODULE_NAME + "/" + ASSIGNMENT_ERROR];
      },
      set(value) {
      },
    },
    formattedUsers() {
      let results = [];
      if (this.user_items === null || !("data" in this.user_items)) return [];
      this.user_filters.pagination = this.user_items;
      this.user_items.data.forEach((item) => {
        results.push({
          id: item.id,
          group: item.groups && item.groups.length ? item.groups[0].name : "-",
          name: item.name,
          surname: item.surname,
          dob: item.dob ? item.dob : "-",
          email: item.email,
          phone: item.phone,
          company_id: item.company_id,
          position_id: item.position_id,
          title_id: item.title_id,
          region_id: item.region_id,
          department_id: item.department_id,
          branch_id: item.branch_id,
          status_id: item.status_id,
          photo_link: item.photo_link,
          is_online: this.onlineUsers.find(
              (onlineUser) => onlineUser.user == item.id && onlineUser.status
          )
              ? true
              : false,
          fullname: [item.name, item.surname].join(" "),
          title: item.title ? item.title.name : "-",
          corporateName: item.corporate?.name || "-",
          created_at: item.created_at
              ? moment(item.created_at).format("DD/MM/YYYY HH:mm:ss")
              : "-",
          last_login_at: item.last_login_at
              ? moment(item.last_login_at).format("DD/MM/YYYY HH:mm:ss")
              : "-",
        });
      });
      return results;
    },
    formattedUserDetail() {
      if (this.user_detail === null) return null;
      return this.user_detail;
    },
    formattedGroupItems() {
      let results = [];
      if (this.group_items === null || !("data" in this.group_items)) return [];
      this.group_filters.pagination = this.group_items;

      for (let i = 0; i < this.group_items.data.length; i++) {
        let currentItem = this.group_items.data[i];
        if (currentItem) {
          results.push({
            id: currentItem.id,
            name: currentItem.name,
            status_id: currentItem.status,
            count: currentItem.count,
            active_users: currentItem.active_users || [],
            created_at: currentItem.created_at
                ? moment(currentItem.created_at).format("DD/MM/YYYY HH:mm:ss")
                : "-",
          });
        }
      }
      return results;
    },
    selectedUsersCount() {
      // manuel seçilen kullanıcılar
      let userCount = this.checked_users ? this.checked_users.length : 0;

      // Eğer isUserListIncluded true ise, grup kullanıcıları checked_group_users'da
      if (this.isUserListIncluded) {
        // bir kullanıcı hem manuel hem grup kullanıcısı olabilir
        let allUsers = [...new Set([...(this.checked_users || []), ...(this.checked_group_users || [])])];
        return allUsers.length;
      }

      // Eğer isUserListIncluded false ise, grup count'unu da ekle
      let checkedGroups = this.checked_groups || [];
      let userGroupCount = _.sumBy(
          _.values(
              this.formattedGroupItems.filter((item) =>
                  checkedGroups.includes(item.id)
              )
          ),
          "count"
      );
      return userCount + userGroupCount;
    },
    isUserChecked() {
      return (userId) => {
        // Kullanıcı hem checked_users'da hem de checked_group_users'da olabilir
        return (this.checked_users && this.checked_users.includes(userId)) || 
               (this.checked_group_users && this.checked_group_users.includes(userId));
      };
    },
    isUserFromGroup() {
      return (userId) => {
        // Kullanıcı grup içinden mi seçildi kontrolu
        return this.checked_group_users && this.checked_group_users.includes(userId);
      };
    },
    formattedUserRequested() {
      let results = [];
      if (this.userRequestedTraining === null || !("data" in this.userRequestedTraining)) return [];
      this.userRequestedTraining.pagination = this.userRequestedTraining;
      this.userRequestedTraining.data.forEach((item) => {
        results.push({
          id: item.id,
          group: item.groups && item.groups.length ? item.groups[0].name : "-",
          name: item.name,
          surname: item.surname,
          dob: item.dob ? item.dob : "-",
          email: item.email,
          phone: item.phone,
          company_id: item.company_id,
          position_id: item.position_id,
          title_id: item.title_id,
          region_id: item.region_id,
          department_id: item.department_id,
          branch_id: item.branch_id,
          status_id: item.status_id,
          photo_link: item.photo_link,
          is_online: this.onlineUsers.find(
              (onlineUser) => onlineUser.user == item.id && onlineUser.status
          )
              ? true
              : false,
          fullname: [item.name, item.surname].join(" "),
          title: item.title ? item.title.name : "-",
          created_at: item.created_at
              ? moment(item.created_at).format("DD/MM/YYYY HH:mm:ss")
              : "-",
          last_login_at: item.last_login_at
              ? moment(item.last_login_at).format("DD/MM/YYYY HH:mm:ss")
              : "-",
        });
      });
      return results;
    }
  },
  methods: {
    triggerUserFilterSearch() {
      this.debouncedFilterUserSearch();
    },
    triggerGroupFilterSearch() {
      this.debouncedFilterGroupSearch();
    },
    linkClick() {
      if (this.is_locked && !this.is_completed && !this.is_unlocked)
        return false;
      this.$emit("linkClick");
    },
    setPage(page, filter_name) {
      this[filter_name].page = page;

      let found = this.checked_user_page.find((element) => element == page);
      if (found) {
        this.selectAllUserText = this.$t("general.deselect_all");
      } else {
        this.selectAllUserText = this.$t("general.Select All");
      }
      if (filter_name === "user_filters") this.filterUsers();
      if (filter_name === "group_filters") this.filterGroups();
    },
    allUserToggle() {
      let self = this;
      this.userChangeCheckItem();
      let found = this.checked_user_page.find(
          (element) => element == this.user_items.current_page
      );

      if ( this.temp_page.find((r) => r === this.user_items.current_page) ==  undefined ) {
        this.formattedUsers.forEach((item) => {
          $("#user_checkbox_" + item.id).prop("checked", true);

          let checked_status = this.checked_users.find((r) => r === item.id);

          if (!checked_status) self.checked_users.push(item.id);
        });

        if (!found) {
          this.checked_user_page.push(this.user_items.current_page);
        }

        this.selectAllUserText = this.$t("general.deselect_all");
        this.temp_page.push(this.user_items.current_page);
      } else {
        this.formattedUsers.forEach((item) => {
          $("#user_checkbox_" + item.id).prop("checked", false);
          this.checked_users = this.checked_users.filter(function (
              checked_user
          ) {
            return checked_user !== item.id;
          });
        });
        this.checked_user_page = this.checked_user_page.filter(function (
            checked_page
        ) {
          return checked_page !== found;
        });
        this.selectAllUserText = this.$t("general.Select All");
        this.temp_page.forEach((e, i) => {
          if (e == self.user_items.current_page) {
            self.temp_page.splice(i, 1);
          }
        });
      }
    },
    sortOrder(sort, order, filter_name) {
      this[filter_name].page = 1;
      this[filter_name].order = order;
      this[filter_name].sort = sort;
      if (filter_name == "user_filters") this.filterUsers();
      if (filter_name == "group_filters") this.filterGroups();
    },
    allGroupToggle(val) {
      this.checked_groups = [];
      this.groupChangeCheckItem();
      if (val) {
        this.formattedGroupItems.forEach((item) => {
          $("#group_checkbox_" + item.id).prop("checked", true);
          this.checked_groups.push(item.id);
        });
        this.selectAllGroupText = this.$t("general.deselect_all");
        this.all_group_checked = false;
      } else {
        this.formattedGroupItems.forEach((item) => {
          $("#group_checkbox_" + item.id).prop("checked", false);
        });
        this.selectAllGroupText = this.$t("general.Select All");
        this.all_group_checked = true;
      }
    },
    getUserDetail(id) {
      store.dispatch(USER_DETAIL_MODULE + "/" + GET_USER_DETAIL, {
        url: "api/user/detail" + "/" + id,
      });
    },
    // aktif kullanıcı filtresinden (lastFilter) tek noktada istek parametreleri üretilir
    buildUserRequestFilters() {
      const self = this.user_filters;
      const activeFilter = this.lastFilter || {};

      let filters = {
        like: self.search,
        page: self.page,
        per_page: self.per_page,
        order: self.order,
        sort: self.sort,
        status_id: 1,
        with: "groups:name",
      };

      // Preview: sadece atanan / tamamlamayan kullanıcılar
      if (this.notAssignmentCompleted) {
        filters.not_assignment_completed = true;
        if (this.assignment_id !== null) {
          filters.assignment_id = this.assignment_id;
        }
      }

      // Institution sayfası: üst kurum kullanıcıları için prop company_id önceliklidir
      if (this.company_id !== null) {
        filters.company_id = this.company_id;
      } else if (activeFilter.company_id) {
        filters.company_id = activeFilter.company_id;
      }

      // {id, name} listesi tutan filtreler API için id dizisine çevrilir
      Object.entries(activeFilter).forEach(([key, value]) => {
        if (!value || !Array.isArray(value) || key === 'company_id') return;
        filters[key] = JSON.stringify(value.map((item) => item.id));
      });

      if (this.$refs.childComponentRef?.filter?.show_only_unassigned_users) {
        filters['assignment_id'] = this.assignment_id;
        filters['show_only_unassigned_users'] = true;
      }

      return filters;
    },
    filterUsers(filter = null) {
      // Yeni filtre geldiyse sakla; gelmediyse (sayfalama, sıralama, arama)
      // en son uygulanan filtreyle devam et
      if (filter) {
        this.lastFilter = filter;
        this.user_filters.page = 1;
      }

      const requestId = ++this.userRequestId;
      this.isUsersLoading = true;
      return this.$store.dispatch(USER_MODULE_NAME + "/" + USER_GET_ITEMS, {
        url: USER_BASE_URL,
        filters: this.buildUserRequestFilters(),
      }).then(result => {
        if (requestId === this.userRequestId && !this._isDestroyed) {
          this.usersListReady = !!result;
        }
      }).finally(() => {
        if (requestId === this.userRequestId) this.isUsersLoading = false;
      });
    },
    filterGroups(filter) {
      let self = this.group_filters;
      let filters = {
        like: self.search,
        page: self.page,
        per_page: self.per_page,
        order_by: self.sort,
        sort: self.order,
        status_id: 1,
        only_user_ids: this.isUserListIncluded // true ise seçilen kullanıcıların id lerini döner
      };
      const requestId = ++this.groupRequestId;
      this.isGroupsLoading = true;
      return this.$store.dispatch(GROUP_MODULE_NAME + "/" + GROUP_GET_ITEMS, {
        url: GROUP_BASE_URL,
        filters: filters,
      }).then(() => {
        if (requestId === this.groupRequestId && !this._isDestroyed) {
          this.groupsListReady = !store.getters[GROUP_MODULE_NAME + "/" + GROUP_ERROR];
        }
      }).finally(() => {
        if (requestId === this.groupRequestId) this.isGroupsLoading = false;
      });
    },
    groupChangeCheckItem() {
      if (this.allow_both_selection) return;
      // this.checked_users = [];
      this.selectAllUserText = this.$t("general.Select All");
      this.all_user_checked = true;
    },
    userChangeCheckItem() {
      if (this.allow_both_selection) return;
      // this.checked_groups = [];
      this.selectAllGroupText = this.$t("general.Select All");
      this.all_group_checked = true;
    },
    handleUserCheckChange(event, userId) {
      const isChecked = event.target.checked;
      
      if (isChecked) {
        // Kullanıcı seçildi, checked_users'a ekle (eğer yoksa)
        if (!this.checked_users.includes(userId)) {
          this.checked_users = [...this.checked_users, userId];
        }
      } else {
        // Kullanıcı kaldırıldı, checked_users'dan çıkar (sadece manuel seçilmişse)
        // Eğer checked_group_users'da varsa, checked_users'dan çıkarılmayack
        if (!this.checked_group_users || !this.checked_group_users.includes(userId)) {
          this.checked_users = this.checked_users.filter(id => id !== userId);
        }
      }
    },
    updateCheckedItems() {
      if (this.added_users.length) {
        this.checked_users = this.added_users;
      }
      if (this.added_groups.length) {
        this.checked_groups = this.added_groups;
      }
    },
  },
  async mounted() {
    // Set initial active tab
    if (this.isUsersActive) {
      this.activeTab = 0;
    } else if (this.isGroupsActive) {
      this.activeTab = 1;
    } else if (this.case_detail === 'usersRequestedTraining') {
      this.activeTab = 2;
    }

    // Initialize sort options
    this.userSortOptions = [
      { id: 'name_asc', name: this.$t('filters.order.a_z') },
      { id: 'name_desc', name: this.$t('filters.order.z_a') },
      { id: 'created_at_asc', name: this.$t('filters.order.created_at_asc') },
      { id: 'created_at_desc', name: this.$t('filters.order.created_at_desc') }
    ];

    this.groupSortOptions = [
      { id: 'name_asc', name: this.$t('filters.order.a_z') },
      { id: 'name_desc', name: this.$t('filters.order.z_a') },
      { id: 'created_at_asc', name: this.$t('filters.order.created_at_asc') },
      { id: 'created_at_desc', name: this.$t('filters.order.created_at_desc') }
    ];

    // company_admin değilse ve bir şirkete atanmışsa
    // ilk yüklemede sadece o şirketin kullanıcıları gelsin.
    // Bu component Announcement, Assignment, Institution vb. birçok yerde ortak kullanıldığı
    // için mantık burada merkezi tutulur.
    const corporateAccess = await getAssignedCorporateAccess();
    this.lastFilter = applyAssignedCorporateToFilter(this.lastFilter, corporateAccess);

    if (this._isDestroyed) return;
    this.filterUsers();
    this.filterGroups();
    this.updateCheckedItems();
    this.debouncedFilterUserSearch = _.debounce(this.filterUsers, 500);
    this.debouncedFilterGroupSearch = _.debounce(this.filterGroups, 500);
  },
  beforeDestroy() {
    this.userRequestId += 1;
    this.groupRequestId += 1;
    if (this.debouncedFilterUserSearch) this.debouncedFilterUserSearch.cancel();
    if (this.debouncedFilterGroupSearch) this.debouncedFilterGroupSearch.cancel();
    const modal = UIkit.modal("#modal-profile");
    if (modal) modal.$destroy(true);
  },
  watch: {
    company_id(val) {
      if (val !== null && val !== undefined) {
        this.filterUsers();
      }
    },
    checked_training(val) {
      if (this.case_detail === 'usersRequestedTraining') {
        let self = this.user_filters;
        let filters = {
          like: self.search,
          page: self.page,
          per_page: self.per_page,
          order: self.order,
          sort: self.sort,
          status_id: 1,
          with: "groups:name",
          can_show_requested_trainings: true,
          training_id: val
        };
        this.$store.dispatch(GET_USER, {
          url: "api/user",
          filters: filters,
          acceptPromise: true,
        })
            .then((result) => {
              if (result?.data) {
                this.userRequestedTraining = result.data;
              }
            });
      }
    },
    "user_filters.activeItem"(value) {
      if (value) {
        this.getUserDetail(value.id);
      }
    },
    added_users(val) {

      if (val.length) this.checked_users = val;
    },
    added_groups(val) {
      if (val.length) this.checked_groups = val;
    },
    "user_filters.search"() {
      this.user_filters.page = 1;

      this.debouncedFilterUserSearch();
    },
    "group_filters.search"() {
      this.debouncedFilterGroupSearch();
    },
    checked_users(val) {
      if (this.with_description) {
        let items = [];
        this.formattedUsers.forEach((item) => {
          if (val.includes(item.id)) items.push(item);
        });
        this.$emit("setCheckedUsers", {ids: val, items: items});
        return;
      }
      this.$emit("setCheckedUsers", val);
    },
    checked_groups(val) {
      if (this.isUserListIncluded) {
        if (!val || val.length === 0) {
          // Hiç grup seçili değilse, checked_group_users'ı temizle
          this.checked_group_users = [];
        } else {
          // Tüm seçili grupların active_users'larını topla
          let groupUsers = [];
          this.formattedGroupItems.forEach((item) => {
            if (val.includes(item.id) && item.active_users && item.active_users.length > 0) {
              groupUsers = groupUsers.concat(item.active_users);
            }
          });
          // Duplicate'leri kaldır ve checked_group_users'a ekle
          this.checked_group_users = [...new Set(groupUsers)];
        }
      }

      if (this.with_description) {
        let items = [];
        this.formattedGroupItems.forEach((item) => {
          if (val.includes(item.id)) items.push(item);
        });
        this.$emit("setCheckedGroups", {ids: val, items: items});
        return;
      }
      this.$emit("setCheckedGroups", val);
    },
  },
};
</script>
<style scoped>
/* ==================== Selected users count ==================== */
.ugs-selected-count {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
  padding: 8px 12px;
  background: #f6f7fb;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
}

/* ==================== Tabs (StepperBreadcrumb) ==================== */
.ugs-tabs {
  margin-bottom: 20px;
}

.ugs-tabs ::v-deep .stepper-breadcrumb__link {
  border-bottom-width: 3px;
}

.ugs-tab-content {
  width: 100%;
}

.ugs-tab-panel {
  width: 100%;
  animation: fadeIn 0.2s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* ==================== Search ==================== */
.ugs-search {
  position: relative;
  width: 100%;
  height: calc(2.25rem + 2px);
  margin-bottom: 12px;
}

.ugs-search__icon {
  position: absolute;
  left: 12px;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  font-size: 18px;
  line-height: 1;
  color: #3f87f5;
  pointer-events: none;
}

.ugs-search__input {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 0 0.75rem 0 38px;
  border: 1px solid #cfd5df;
  border-radius: 10px;
  color: #1e293b;
  font-size: 14px;
  line-height: 1.5;
  background: #fff;
}

.ugs-search__input:focus {
  border-color: var(--primaryColor, #3e416d);
  box-shadow: 0 0 0 3px rgba(62, 65, 109, 0.16);
  outline: none;
}

/* ==================== Action bar (bulk left + sort/filter right) ==================== */
.ugs-action-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 0 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #e2e8f0;
}

.ugs-action-bar__left {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
  flex: 0 0 auto;
  min-width: 0;
}

.ugs-action-bar__right {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
}

.ugs-bulk-btn {
  height: 40px;
  min-height: 40px;
  padding: 0 14px;
  font-size: 14px;
  white-space: nowrap;
  border-radius: 10px;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  flex-shrink: 0;
}

.ugs-per-page-select {
  flex: 0 0 auto;
  min-width: 80px;
  max-width: 100px;
  margin-left: auto;
}

.ugs-per-page-select ::v-deep .form-group {
  margin: 0 !important;
  margin-bottom: 0 !important;
}

.ugs-per-page-select ::v-deep label {
  display: none !important;
}

.ugs-per-page-select ::v-deep .multiselect {
  min-height: 40px !important;
  height: 40px !important;
  font-size: 14px;
}

.ugs-per-page-select ::v-deep .multiselect__tags {
  min-height: 40px !important;
  height: 40px !important;
  padding: 8px 30px 8px 10px !important;
  border-radius: 10px;
  border: 1px solid #cfd5df;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.ugs-per-page-select ::v-deep .multiselect__select {
  height: 40px !important;
  width: 30px !important;
  top: 0 !important;
  right: 0 !important;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ugs-per-page-select ::v-deep .multiselect__select::before {
  position: relative !important;
  top: 0 !important;
  margin: 0 !important;
  border-width: 5px 5px 0 5px !important;
  border-style: solid;
  border-color: #999 transparent transparent transparent;
}

.ugs-per-page-select ::v-deep .multiselect__single {
  margin: 0;
  padding: 0;
  font-size: 14px;
  line-height: 1.5;
}

.ugs-per-page-select ::v-deep .multiselect__placeholder {
  margin: 0;
  padding: 0;
  font-size: 14px;
  line-height: 1.5;
}

/* ==================== Sort select ==================== */
.ugs-sort-select {
  min-width: 160px;
}

.ugs-sort-select ::v-deep .form-group {
  margin: 0;
}

.ugs-sort-select ::v-deep label {
  display: none;
}

.ugs-sort-select ::v-deep .multiselect {
  min-height: 40px;
  height: 40px;
  font-size: 14px;
}

.ugs-sort-select ::v-deep .multiselect__tags {
  min-height: 40px;
  height: 40px;
  padding: 8px 40px 8px 12px;
  border-radius: 10px;
  border: 1px solid #cfd5df;
  box-sizing: border-box;
}

.ugs-sort-select ::v-deep .multiselect__select {
  height: 40px;
}

.ugs-sort-select ::v-deep .multiselect__single {
  margin: 0;
  padding: 0;
  font-size: 14px;
  line-height: 1.5;
}

.ugs-sort-select ::v-deep .multiselect__content-wrapper {
  border: 1px solid #cfd5df;
  border-radius: 10px;
  margin-top: 4px;
}

.ugs-sort-select ::v-deep .multiselect__option {
  font-size: 14px;
  padding: 10px 12px;
  min-height: 40px;
}

.ugs-sort-select ::v-deep .multiselect__option--highlight {
  background: #f1f5f9;
  color: #1e293b;
}

.ugs-sort-select ::v-deep .multiselect__option--selected {
  background: var(--primaryColor, #3e416d);
  color: #fff;
  font-weight: 600;
}

/* ==================== Table ==================== */
.users-table .table th,
.users-table .table td {
  font-size: 14px;
  vertical-align: middle;
  line-height: 1.4;
}

.users-table .table .media-body .name {
  font-size: 14px;
  font-weight: 600;
}

.users-table .table .media-body small {
  font-size: 12px;
  color: #64748b;
}

.ugs-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  min-height: 40px;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  color: #64748b;
  font-size: 18px;
  text-decoration: none;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  transition: background-color 0.15s;
}

.ugs-icon-btn:active {
  transform: scale(0.95);
  opacity: 0.8;
}

/* ==================== Checkbox ==================== */
.checkbox-wrapper {
  display: block;
  position: relative;
}

.user-checkbox {
  width: 20px;
  height: 20px;
  margin: 0;
  display: block;
  position: relative;
  z-index: 1;
}

.group-checkbox {
  width: 20px;
  height: 20px;
  margin: 0 10px 0 0;
}

input[type="checkbox"]:focus {
  box-shadow: none !important;
}

/* ==================== Misc ==================== */
.bg-offline {
  background-color: #c0c0c0 !important;
}

.group-user-badge {
  display: inline-flex;
  align-items: center;
  margin-left: 6px;
  padding: 2px 6px;
  background-color: #e3f2fd;
  border: 1px solid #2196f3;
  border-radius: 12px;
  font-size: 11px;
  color: #1976d2;
  vertical-align: middle;
}

.group-user-badge i {
  font-size: 12px;
  margin: 0;
}

input[type="checkbox"]:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: #e3f2fd;
  border-color: #2196f3;
}

input[type="checkbox"]:disabled:checked {
  background-color: #2196f3;
  border-color: #2196f3;
}

/* ==================== Mobile (959px) ==================== */
@media (max-width: 959px) {
  .ugs-tabs {
    margin-bottom: 16px;
  }

  .ugs-tabs ::v-deep .stepper-breadcrumb__link {
    min-height: 52px;
    padding: 16px 16px;
    font-size: 15px;
  }

  .ugs-tabs ::v-deep .stepper-breadcrumb__icon {
    font-size: 19px;
  }

  .ugs-search {
    height: 44px;
  }

  .ugs-search__input {
    padding: 0 14px 0 42px;
    font-size: 16px;
  }

  .ugs-search__icon {
    left: 14px;
    font-size: 20px;
  }

  .ugs-action-bar {
    flex-wrap: wrap;
    gap: 10px;
    padding: 0 0 12px;
    margin-bottom: 12px;
  }

  .ugs-action-bar__left {
    width: 100%;
    flex: 1 1 100%;
    flex-wrap: nowrap;
    gap: 10px;
    justify-content: space-between;
  }

  .ugs-action-bar__right {
    width: 100%;
    flex: 1 1 100%;
    flex-wrap: nowrap;
    gap: 10px;
  }

  .ugs-icon-btn {
    min-width: 48px;
    min-height: 48px;
    width: 48px;
    height: 48px;
    font-size: 20px;
    border-radius: 12px;
  }

  .ugs-bulk-btn {
    height: 48px;
    min-height: 48px;
    padding: 0 18px;
    font-size: 16px;
    border-radius: 12px;
  }

  .ugs-per-page-select {
    flex: 0 0 auto;
    min-width: 100px;
    max-width: 120px;
    width: 100px;
    margin-left: 0;
  }

  .ugs-per-page-select ::v-deep .multiselect {
    min-height: 48px !important;
    height: 48px !important;
    font-size: 16px;
  }

  .ugs-per-page-select ::v-deep .multiselect__tags {
    min-height: 48px !important;
    height: 48px !important;
    padding: 12px 35px 12px 12px !important;
    border-radius: 12px;
    display: flex;
    align-items: center;
  }

  .ugs-per-page-select ::v-deep .multiselect__select {
    height: 48px !important;
    width: 35px !important;
    top: 0 !important;
    right: 0 !important;
    padding: 0 !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ugs-per-page-select ::v-deep .multiselect__select::before {
    position: relative !important;
    top: 0 !important;
    margin: 0 !important;
    border-width: 5px 5px 0 5px !important;
    border-style: solid;
    border-color: #999 transparent transparent transparent;
  }

  .ugs-per-page-select ::v-deep .multiselect__single {
    font-size: 16px;
    line-height: 1.5;
  }

  .ugs-per-page-select ::v-deep .multiselect__placeholder {
    font-size: 16px;
    line-height: 1.5;
  }

  .ugs-sort-select {
    flex: 1;
    min-width: 0;
    max-width: none;
  }

  .ugs-sort-select ::v-deep .multiselect {
    min-height: 48px;
    height: 48px;
    font-size: 16px;
  }

  .ugs-sort-select ::v-deep .multiselect__tags {
    min-height: 48px;
    height: 48px;
    padding: 12px 40px 12px 14px;
    border-radius: 12px;
  }

  .ugs-sort-select ::v-deep .multiselect__select {
    height: 48px;
  }

  .ugs-sort-select ::v-deep .multiselect__single {
    font-size: 16px;
    line-height: 1.5;
  }

  .ugs-sort-select ::v-deep .multiselect__option {
    font-size: 16px;
    padding: 12px 14px;
    min-height: 48px;
  }

  .ugs-selected-count {
    font-size: 14px;
    padding: 10px 12px;
  }

  /* Table mobile */
  .users-table {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .users-table .table th,
  .users-table .table td {
    padding: 10px 8px;
    font-size: 14px;
  }

  .users-table .table thead th {
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
  }

  .users-table .table .media {
    gap: 8px;
  }

  /* Hide avatar/icon wrapper in first column on mobile */
  .users-table .table .media .ugs-avatar-wrap {
    display: none;
  }

  .users-table .table .media-body {
    margin-left: 0 !important;
  }

  .users-table .table .media-body .name {
    font-size: 14px;
    word-break: break-word;
  }

  .users-table .table .actions .btn {
    min-width: 44px;
    min-height: 44px;
  }
}

/* ==================== Hover ==================== */
@media (hover: hover) and (pointer: fine) {
  .ugs-icon-btn:hover {
    background: #f6f7fb;
    color: var(--primaryColor, #3e416d);
    cursor: pointer;
  }

  .ugs-bulk-btn:hover {
    cursor: pointer;
    opacity: 0.9;
  }
}

/* ==================== Reduced Motion ==================== */
@media (prefers-reduced-motion: reduce) {
  .ugs-tab-panel {
    animation: none;
  }

  .ugs-icon-btn:active {
    transform: none;
  }
}
</style>
